import { debounce, memoize } from "lodash";
import { defineStore } from "pinia";
import { reactive } from "vue";
import { useBuiltComponentStore } from "../component-built";
import { createComponentVariableSearchables } from "./createComponentVariableSearchables";
export const useComponentVariableSearchableStore = defineStore("ComponentVariableSearchableStore", () => {
    const builtComponentStore = useBuiltComponentStore();
    const state = reactive({});
    const getComponentVariableSearchables = (componentId) => {
        return Object.values(state[componentId] || {});
    };
    const getOrCreateComponentVariableSearchablesMap = (componentId) => {
        if (!state[componentId]) {
            state[componentId] = {};
        }
        return state[componentId];
    };
    const provideDebouncedUpdateFn = memoize((componentId) => {
        return debounce(() => {
            const builtComponent = builtComponentStore.getBuiltComponent(componentId);
            if (!builtComponent) {
                return;
            }
            const searchablesMap = getOrCreateComponentVariableSearchablesMap(componentId);
            const searchables = createComponentVariableSearchables(builtComponent);
            searchables.forEach((searchable) => {
                searchablesMap[searchable.name] = searchable;
            });
        }, 100);
    });
    const recalculateSearchables = (componentId) => {
        provideDebouncedUpdateFn(componentId)();
    };
    return {
        state,
        getComponentVariableSearchables,
        recalculateSearchables,
    };
});
